import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicantService } from 'src/app/services/applicant.service';
import { CoApplicantService } from 'src/app/services/co-applicant.service';
import { QuestionService } from 'src/app/services/question.service';
@Component({
  selector: 'app-sidenav-applicant',
  templateUrl: './sidenav-applicant.component.html',
  styleUrls: ['./sidenav-applicant.component.css']
})
export class SidenavApplicantComponent implements OnInit {
  udata: any;
  userStatusLi: any;
  username: any;
  section: any;
  criterias: any[] = [];
  navToCoDirectly: boolean = false;
  btnDisabled: boolean = false;
  showSectionsandPRev: boolean = false;
  coid: string = '';
  activeRoute: string = '';
  criteriaWise!: { [key: string]: string[] };
  headers: any = {
    'Criteria 1': {
      A: 'General Regulatory Requirements',
      B: 'Food Safety Practices',
    },
    'Criteria 11': {
      A: 'Statutory, Regulatory and Social Compliance',
      B: 'Laboratory Management',
      C: 'Leadership and Best Practices in Laboratory Initiatives',
    },
    'Criteria 2A for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2A Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2B for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2B Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 4': {
      A: 'Social & Regulatory Requirement',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 5': [],
    'Criteria 7': {
      A: 'Self-Declaration',
      B4: 'Management of Partnerships',
    },
    'Criteria 9': {
      A: 'Statutory & Regulatory Requirements & Social Compliance',
      B1: 'Pre Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Good Manufacturing Practices (GMP)',
      D: 'Change Management Initiatives'
    },
  }

  constructor(
    private router: Router,
    private quest: QuestionService,
    private applicat: ApplicantService,
    private coapp: CoApplicantService,
    private route: ActivatedRoute
  ) { }
  logout() {
    localStorage.removeItem('user')
    localStorage.removeItem('username')
  }
  sortObjectKeysAlphabetically(obj: { [key: string]: any }): { key: string, value: any }[] {
    return Object.keys(obj)
      .sort((a, b) => a.localeCompare(b)) // Sort keys alphabetically
      .map(key => ({ key: key, value: obj[key] }));
  }
  ngOnInit(): void {
    this.username = localStorage.getItem('username') ? localStorage.getItem('username') : this.router.navigate(['/login'])
    this.udata = localStorage.getItem('userdata');
    this.udata = JSON.parse(this.udata);
    let email = this.udata.email;
    this.activeRoute = this.router.url;
    this.router.events.subscribe(() => {
      this.activeRoute = this.router.url;
    });
    this.applicat
      .GetAdminApplicantSinglebyemail(email)
      .subscribe((data: any) => {
        // this.userStatusLi=data.applicanData.userStatus;
        if (
          data.applicanData.criteria != '' &&
          data.applicanData.userStatus === true
        ) {
          this.coapp.listCoApplicant(data.applicanData._id).subscribe((resp: any) => {
            if (resp.result.length) {
              this.navToCoDirectly = true
              this.coid = resp.result[0]._id
              if (resp.result[0].userStatus) {
                this.showSectionsandPRev = true
              }
              let criterias = resp.result.map((coapps: any) => {
                return coapps.co_criteria
              })
              this.criterias = [data.applicanData.criteria].concat(criterias)
              this.criterias = Array.from(new Set(this.criterias))
            } else {
              this.criterias = [data.applicanData.criteria]
              this.showSectionsandPRev = true
            }
            this.quest.isFinalAssessed({
              email: this.udata.email,
              criteria: this.criterias[0],
              type: this.udata.role,
            }).subscribe((ittem: any) => {
              if (ittem.statuscode == 200) {
                this.btnDisabled = true;
              } else {
                this.btnDisabled = false;
              }
            });
            this.quest
              .viewQuestionSections({ criterias: this.criterias })
              .subscribe((item: any) => {
                this.section = item.sections;
                this.criteriaWise = item.criterias;
                for (const category in this.criteriaWise) {
                  if (this.criteriaWise.hasOwnProperty(category)) {
                    this.criteriaWise[category].sort((a, b) => a.localeCompare(b));
                  }
                }
              });
          })
          // this.quest
          //   .viewQuestionSec({ criteria: data.applicanData.criteria })
          //   .subscribe((item: any) => {
          //     this.section = item.sections;
          //   });
        } else {
        }
      })
  }
  goToSection(section: string, index: number) {
    let route = 'section';
    if (index == 1) {
      route = 'sectionco'
    }
    this.router.navigate([route, section, 0], { queryParams: { criteria: this.criterias[index] } })
  }
  isActive(route: string): boolean {
    return this.activeRoute.includes(route);
  }
  amIActive(section: string, index: number) {
    let route = 'section';
    if (index == 1) {
      route = 'sectionco'
    }
    return this.isActive(route + "/" + section + "/")
  }
  amIActiveInPrev(index: number) {
    let route = 'preview';
    if (index == 1) {
      route = 'prev-co'
    }
    return this.isActive(route)
  }
  goToPreview(index: number) {
    let route = 'preview';
    if (index == 1) {
      route = 'prev-co'
    }
    this.router.navigate([route])
  }
}
